import { c as _c } from "react/compiler-runtime";
import type { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import type { WaveOverviewConfig } from "@/types/waves.types";
import CreateWaveImageInput from "./CreateWaveImageInput";
import CreateWaveNameInput from "./CreateWaveNameInput";
import CreateWaveType from "./type/CreateWaveType";
export default function CreateWaveOverview(t0) {
  const $ = _c(22);
  const {
    overview,
    errors,
    setOverview
  } = t0;
  let t1;
  if ($[0] !== overview || $[1] !== setOverview) {
    t1 = t2 => {
      const {
        key,
        value
      } = t2;
      return setOverview({
        ...overview,
        [key]: value
      });
    };
    $[0] = overview;
    $[1] = setOverview;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onChange = t1;
  let t2;
  if ($[3] !== errors || $[4] !== onChange || $[5] !== overview.name) {
    t2 = <CreateWaveNameInput onChange={onChange} name={overview.name} errors={errors} />;
    $[3] = errors;
    $[4] = onChange;
    $[5] = overview.name;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="tw-mb-0 tw-text-lg  sm:tw-text-xl tw-font-semibold tw-text-iron-50">Wave Profile Picture</p>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onChange) {
    t4 = file => onChange({
      key: "image",
      value: file
    });
    $[8] = onChange;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== overview.image || $[11] !== t4) {
    t5 = <div className="tw-space-y-2">{t3}<CreateWaveImageInput imageToShow={overview.image} setFile={t4} /></div>;
    $[10] = overview.image;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onChange) {
    t6 = type => onChange({
      key: "type",
      value: type
    });
    $[13] = onChange;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== overview.type || $[16] !== t6) {
    t7 = <CreateWaveType selected={overview.type} onChange={t6} />;
    $[15] = overview.type;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t2 || $[19] !== t5 || $[20] !== t7) {
    t8 = <div className="tw-flex tw-flex-col tw-space-y-6">{t2}{t5}{t7}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}